module.exports = __webpack_public_path__ + "img/Tk3-Board.b43e4f64.png";